<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    @if (hasDurationFilter()) {
      <IAlert>
        {{ t("media-input.only_deal_durations_shown", { durations: allowedDurationsLabel() }) }}
      </IAlert>
    }
    @if (!modalData.disableUpload) {
      <ITabs [tabs]="tabs" [activeTab]="selectedTab" (activeTabChange)="selectedTab = $event!" />
    }
    <div class="flex h-[50vh] flex-col overflow-y-auto">
      @if (selectedTab === MediaInputTab.MEDIA) {
        @if (durationsLoading()) {
          <div class="flex flex-1 items-center justify-center">
            <ISpinner withTitle />
          </div>
        } @else {
          <app-media-selection
            [medias]="medias()"
            [mediaType]="modalData.mediaType"
            [imageSizeFilterValues]="modalData.imageSizeFilterValues"
            [(selectedMedia)]="selectedMedia"
          />
        }
      } @else if (selectedTab === MediaInputTab.UPLOAD_NEW) {
        <div class="flex flex-1 flex-col items-center justify-center gap-3 p-3">
          @if (newMediaFile && media()) {
            <ng-container *ngTemplateOutlet="newFileCard; context: { file: newMediaFile }"></ng-container>
          }
          @if (invalidReason()) {
            <IAlert class="mb-2" type="error" [title]="invalidReason()">
              {{ mediaConstraintsTip() }}
            </IAlert>
          }
          <input
            #fileInput
            hidden
            type="file"
            [accept]="isVideo() ? 'video/*' : 'image/gif, image/jpeg, image/png'"
            (input)="onNewMedia(fileInput.files)"
            (click)="fileInput.value = ''"
          />
          <button iButton variant="secondary" (click)="fileInput.click()">
            <IIcon name="import" />
            {{ t("media-input.choose_file") }}
          </button>
        </div>
      }
    </div>
  </div>
  <div class="flex justify-end gap-2 pt-2">
    @if (selectedTab === MediaInputTab.MEDIA) {
      <button iButton variant="secondary" size="md" (click)="modalRef && modalRef.close()">
        {{ t("common.cancel") }}
      </button>
      <button iButton size="md" [disabled]="!selectedMedia" testId="btn-media-save" (click)="saveMedia(selectedMedia)">
        {{ t("common.save") }}
      </button>
    }
    @if (selectedTab === MediaInputTab.UPLOAD_NEW) {
      <button iButton variant="secondary" size="md" (click)="modalRef && modalRef.close()">
        {{ t("common.cancel") }}
      </button>
      <button
        iButton
        size="md"
        [disabled]="!newMediaFile || invalidReason().length > 0"
        (click)="saveNewFile(newMediaFile)"
      >
        {{ t("media-input.save_and_upload_new_file") }}
      </button>
    }
  </div>

  <ng-template #newFileCard let-f="file">
    @if (isVideo()) {
      <div class="w-2/3 rounded border border-gray-100 p-2">
        @if (media().src) {
          <video>
            <source [src]="media().src + '#t=0.1'" type="video/mp4" />
          </video>
        }
        <div class="mt-2 flex w-full items-center justify-between">
          <div class="media-filename truncate text-sm font-semibold">{{ f.name }}</div>
          <button
            iButton
            variant="secondary"
            size="icon-sm"
            [iTooltip]="t('media-input.preview_video')"
            (click)="openMediaToPreview(undefined); $event.stopPropagation()"
          >
            <IIcon name="eye" />
          </button>
        </div>
      </div>
    } @else {
      <img [src]="media().src" alt="Uploaded Media" />
      <div class="media-filename truncate text-sm font-semibold">{{ f.name }}</div>
    }
  </ng-template>
</ng-container>
